const zh = {
  header: {
    tip1:
      "In order to prevent the system from accidentally closing the game in your virtual space, causing your game to be disconnected in unknown circumstances, you need to manually follow the following steps to complete the setting.",
  },
  content: {
    list1: {
      title: "Add the virtual master [lock] and save the background running.",
    },
    list2: {
      title: "Go to Phone Settings - Search [App Launch Management]】",
    },
    list3: {
      title:
        "Search for virtual masters, open allow from startup, open allow background activities.",
    },
  },
};

export default zh;
